<template>
    <span v-if="Array.isArray(text)">
        {{ ['Success','Error','Default','Processing','Warning'].indexOf((item['dictStyle'] || ''))>-1 }}
        <span v-for="(item,index) in text" :key="index">
        <span v-if="item && !item['dictStyle']">{{ item['dictValue'] }}</span>
        <a-badge v-else-if="item && item['dictStyle'] && ['Success','Error','Default','Processing','Warning'].indexOf((item['dictStyle'] || ''))>-1" :status="item['dictStyle'].toLowerCase() || 'default'" :text="item['dictValue']" />
        <a-tag v-else-if="item && item['dictStyle'] === 'default'" :color="''" >{{ item['dictValue'] }}</a-tag>
        <a-tag v-else-if="item && item['dictStyle'] && ['Success','Error','Default','Processing','Warning'].indexOf((item['dictStyle'] || ''))==-1" :color="item['dictStyle'] || 'default'" >{{ item['dictValue'] }}</a-tag>
        <span v-else> - </span>
        </span>
    </span>
    <span v-else>
        <span v-if="text && !text['dictStyle']">{{ text['dictValue'] }}</span>
        <a-badge v-else-if="text && text['dictStyle'] && ['Success','Error','Default','Processing','Warning'].indexOf(text['dictStyle'])>-1" :status="text['dictStyle'].toLowerCase() || 'default'" :text="text['dictValue']" />
        <a-tag v-else-if="text && text['dictStyle'] === 'default'" :color="''" >{{ text['dictValue'] }}</a-tag>
        <a-tag v-else-if="text && text['dictStyle'] && ['Success','Error','Default','Processing','Warning'].indexOf(text['dictStyle'])==-1" :color="text['dictStyle'] || 'default'" >{{ text['dictValue'] }}</a-tag>
        <span v-else> - </span>
    </span>
</template>

<script>
export default {
    name: 'DicStatus',
    props:['text']
}
</script>

<style>

</style>